import styled from 'styled-components'

export const StyledButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 20px 0;
`
